export default __webpack_public_path__ + "static/media/1 (5).0a27f0bf.png";